// Simple global handler for all "Copy code" buttons

document.addEventListener('click', function (event) {
  // Click on the button or inside it
  const button = event.target.closest('.js-copy-button');
  if (!button) return;

  // Find the wrapper that contains code + success message
  const wrapper = button.closest('.discount-code');
  if (!wrapper) return;

  const codeEl = wrapper.querySelector('.js-discount-code');
  const successEl = wrapper.querySelector('.js-copy-success');

  if (!codeEl) return;

  const code = (codeEl.textContent || '').trim();
  if (!code) return;

  copyTextToClipboard(code)
    .then(function () {
      // Show "Code copied!" overlay if present
      if (successEl) {
        successEl.setAttribute('aria-hidden', 'false');
        setTimeout(function () {
          successEl.setAttribute('aria-hidden', 'true');
        }, 2000);
      }
    })
    .catch(function (err) {
      console.error('Failed to copy discount code', err);
    });
});

function copyTextToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  // Fallback for older browsers
  return new Promise(function (resolve, reject) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      resolve();
    } catch (e) {
      reject(e);
    }
  });
}
